// The QR landing — /r/:rid/s/:sid/t/:tableId. Scanning the code on the
// table seats the session: dine-in is preset and the table rides checkout.

import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { fetchPublicTables, fetchStore, type StorePublic } from '../lib/api';
import { pinTable } from '../lib/dinein';

export function TableWelcome() {
  const { rid, sid, tableId } = useParams() as { rid: string; sid: string; tableId: string };
  const nav = useNavigate();
  const [store, setStore] = useState<StorePublic | null>(null);
  const [tableName, setTableName] = useState<string | null>(null);
  const [bad, setBad] = useState(false);

  useEffect(() => {
    fetchStore(rid, sid).then(setStore, () => setBad(true));
    fetchPublicTables(rid, sid).then(
      (ts) => {
        const t = ts.find((x) => x.tableId === tableId);
        if (t) setTableName(t.name);
        else setBad(true);
      },
      () => setBad(true),
    );
  }, [rid, sid, tableId]);

  if (bad) {
    return (
      <div className="tw-page">
        <div className="tw-card">
          <h1 className="serif">Hmm — that code didn't work</h1>
          <p>The QR on this table isn't recognised. You can still browse the menu and order at the counter.</p>
          <button className="tw-start" onClick={() => nav(`/r/${rid}/s/${sid}`)}>View the menu</button>
        </div>
      </div>
    );
  }

  if (!store || !tableName) return <div className="loading">Setting your table…</div>;

  if (!store.dineInEnabled || store.temporarilyClosed || store.permanentlyClosed) {
    return (
      <div className="tw-page">
        <div className="tw-card">
          <h1 className="serif">Table ordering is taking a break</h1>
          <p>Please order with our crew — thank you! ⭐</p>
          <button className="tw-start" onClick={() => nav(`/r/${rid}/s/${sid}`)}>View the menu</button>
        </div>
      </div>
    );
  }

  return (
    <div className="tw-page">
      <div className="tw-card" data-table={tableId}>
        <div className="tw-brand">{store.name}</div>
        <h1 className="serif">Welcome</h1>
        <p>You're seated at <b>{tableName}</b>. Order here and we'll bring it over.</p>
        <button
          className="tw-start"
          onClick={() => {
            pinTable({ storeKey: `${rid}/${sid}`, tableId, tableName });
            nav(`/r/${rid}/s/${sid}?dinein=1`);
          }}
        >
          Start your order
        </button>
      </div>
    </div>
  );
}
